import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import {
  DEFAULT_GUIDE_SLOT_PACKS,
  GuideSlotBalance,
  GuideSlotPack,
  GuideSlotService,
} from "src/app/Services/guide-slot.service";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import {
  resolveCoinPurchaseReturnUrl,
  setCoinPurchaseReturnUrl,
} from "src/app/shared/utils/coin-purchase-return.util";

export interface GuideSlotPurchaseDialogData {
  packs?: GuideSlotPack[];
  balance?: GuideSlotBalance | null;
  selectedPackId?: string;
  returnUrl?: string;
}

@Component({
  selector: "app-guide-slot-purchase-dialog",
  templateUrl: "./guide-slot-purchase-dialog.component.html",
  styleUrls: ["./guide-slot-purchase-dialog.component.scss"],
})
export class GuideSlotPurchaseDialogComponent implements OnInit {
  guidePacks: GuideSlotPack[] = [...DEFAULT_GUIDE_SLOT_PACKS];
  guideBalance: GuideSlotBalance | null = null;
  selectedPackId = "try";
  isLoading = false;
  isLoggedIn = false;

  constructor(
    private dialogRef: MatDialogRef<GuideSlotPurchaseDialogComponent>,
    private router: Router,
    private guideSlotService: GuideSlotService,
    private authModalService: AuthModalService,
    @Inject(MAT_DIALOG_DATA) public data: GuideSlotPurchaseDialogData
  ) {}

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
    this.isLoggedIn = !!user;

    if (this.data?.packs?.length) {
      this.guidePacks = this.data.packs;
    }
    if (this.data?.balance) {
      this.guideBalance = this.data.balance;
    }
    if (this.data?.selectedPackId) {
      this.selectedPackId = this.data.selectedPackId;
    } else if (this.guidePacks.length > 1) {
      this.selectedPackId = this.guidePacks[1].id;
    }

    if (this.isLoggedIn && !this.guideBalance) {
      this.loadBalance();
    }
  }

  get selectedPack(): GuideSlotPack {
    return (
      this.guidePacks.find((p) => p.id === this.selectedPackId) ||
      this.guidePacks[0]
    );
  }

  selectPack(packId: string): void {
    this.selectedPackId = packId;
  }

  close(): void {
    this.dialogRef.close();
  }

  purchase(): void {
    const packId = this.selectedPack?.id;
    if (!packId) {
      return;
    }

    const returnUrl = resolveCoinPurchaseReturnUrl(this.data?.returnUrl);
    const queryParams: { [key: string]: string } = { pack: packId };
    if (returnUrl) {
      queryParams.returnUrl = returnUrl;
      setCoinPurchaseReturnUrl(returnUrl);
    }

    if (!this.isLoggedIn) {
      this.dialogRef.close();
      const target = `/purchase-guide-slots?${new URLSearchParams(
        queryParams
      ).toString()}`;
      this.authModalService.openModal("registration", target);
      return;
    }

    this.dialogRef.close({ purchased: true, packId });
    this.router.navigate(["/purchase-guide-slots"], { queryParams });
  }

  private loadBalance(): void {
    this.isLoading = true;
    this.guideSlotService.getBalance().subscribe({
      next: (balance) => {
        this.guideBalance = balance;
        if (balance.packs?.length) {
          this.guidePacks = balance.packs;
        }
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }
}
